// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".w8IS\\+GHx{align-items:center;display:inline-flex;font-weight:500;justify-content:center;padding:2px}.w8IS\\+GHx>*+*{margin-left:.5em}.xRnMll10{align-items:center;color:var(--color-blue);display:flex;justify-content:center;transition:.1s linear;transition-property:color}@media(hover:hover){.xRnMll10:hover{color:#ff2a1c}}@media(hover:none){.xRnMll10:active{color:#ff2a1c}}.QBR79nwf{color:#ff2a1c}@media(hover:hover){.QBR79nwf:hover{color:#b50b00}}@media(hover:none){.QBR79nwf:active{color:#b50b00}}.Cde9grAO{--size:1.8em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "w8IS+GHx",
	"btn": "xRnMll10",
	"btnLiked": "QBR79nwf",
	"icon": "Cde9grAO"
};
module.exports = ___CSS_LOADER_EXPORT___;
